export enum PurchaseTermsLevelEnum {
  VENDOR = 'vendor',
  BRAND = 'brand',
  SKU = 'sku',
}

export enum RuleGroupLevelEnum {
  VENDOR = 'VENDOR',
  BRAND = 'BRAND',
  SKU = 'SKU',
}

export type RuleGroupConfigType = {
  id?: number
  brand_id?: number
  l1_category_id?: number
  l2_category_id?: number
  brand_name?: string
  l1_category_name?: string
  l2_category_name?: string
  brand_is_active?: boolean
  l1_category_is_active?: boolean
  l2_category_is_active?: boolean
  marked_for_deletion?: boolean
}

export type RuleGroupConfigProductType = {
  id?: number
  product_id: number
  product_name?: string
  sku_number?: string
  inactive_reason?: string
  is_active?: boolean
}

export type PurchaseTermsNamedItemType = {
  id: number
  name: string
}

export type RuleGroupInactiveFilterItemType = {
  id?: number
  name: string
}

export type RuleGroupInactiveFiltersType = {
  brands?: RuleGroupInactiveFilterItemType[]
  l1_categories?: RuleGroupInactiveFilterItemType[]
  l2_categories?: RuleGroupInactiveFilterItemType[]
}

export type RuleGroupType = {
  id?: number
  level: RuleGroupLevelEnum
  order_requirement: 'MoQ Only' | 'MoV Only' | 'None'
  moq_qty?: number
  moq_multiplier?: number
  moq_uom?: string
  mov?: number
  notes?: string
  is_active?: boolean
  marked_for_deletion?: boolean
  last_validated_at?: string
  shipping_fee_rules?: boolean
  shipping_fee_amount?: string
  configs?: RuleGroupConfigType[]
  products?: RuleGroupConfigProductType[]
  product_ids?: number[]
  inactive_filters?: RuleGroupInactiveFiltersType
}

export type BrandScopeInactiveIdsType = {
  brand_ids?: number[]
  l1_category_ids?: number[]
  l2_category_ids?: number[]
}

export type SkuScopeInactiveIdsType = {
  product_ids?: number[]
}

export type BrandScopeSkuListItemType = {
  id: number
  name: string
  brand_name: string
  l1_category_name: string
  l2_category_name: string
}

export type BrandOrderRequirementType = {
  id?: number
  client_key?: string
  brands: PurchaseTermsNamedItemType[]
  l1Categories: RuleGroupInactiveFilterItemType[]
  l2Categories: RuleGroupInactiveFilterItemType[]
  order_requirement: 'MoQ Only' | 'MoV Only'
  moq_qty?: number
  moq_uom?: string
  moq_multiplier?: number
  mov: string
  notes: string
  is_inactive: boolean
  marked_for_deletion: boolean
  inactive_scope_ids?: BrandScopeInactiveIdsType
  inactive_filters?: RuleGroupInactiveFiltersType
  rule_group_configs?: RuleGroupConfigType[]
  last_validated_at?: string
}

export type SkuOrderRequirementType = {
  id?: number
  client_key?: string
  products: PurchaseTermsNamedItemType[]
  order_requirement: 'MoQ Only' | 'MoV Only'
  moq_qty?: number
  moq_uom?: string
  moq_multiplier?: number
  mov: string
  notes: string
  is_inactive: boolean
  marked_for_deletion: boolean
  inactive_scope_ids?: SkuScopeInactiveIdsType
  rule_group_products?: RuleGroupConfigProductType[]
  last_validated_at?: string
}

export type PurchaseTermsOrderRequirementType = 'MoQ Only' | 'MoV Only'

export type PurchaseTermsApiResponseType<T> = {
  data: T
  error: { status: boolean }
}

export type BrandCategoryL2ApiType = {
  level?: string
  category_id: number
  category_name: string
  subcategories?: BrandCategoryL2ApiType[]
}

export type BrandCategoryL1ApiType = {
  level?: string
  category_id: number
  category_name: string
  subcategories?: BrandCategoryL2ApiType[]
}

export type BrandCategoriesApiItemType = {
  brand_id: number
  brand_name: string
  categories: BrandCategoryL1ApiType[]
}

export type GetBrandCategoriesDataType = {
  brands?: BrandCategoriesApiItemType[]
}

export type GetBrandCategoriesResponseType =
  PurchaseTermsApiResponseType<GetBrandCategoriesDataType> & GetBrandCategoriesDataType

export type GetBrandsResponseType = PurchaseTermsApiResponseType<PurchaseTermsNamedItemType[]>

export type GetCategoriesResponseType = PurchaseTermsApiResponseType<PurchaseTermsNamedItemType[]>

export type GetProductsResponseType = PurchaseTermsApiResponseType<PurchaseTermsNamedItemType[]>

export enum VendorListProductSearchTypeEnum {
  ALL = 'all',
  PRODUCT_NAME = 'product_name',
  SKU_NUMBER = 'sku_number',
}

export enum VendorListProductSourceStatusEnum {
  SOURCE = 'source',
  NOT_SOURCE = 'not_source',
  DISCONTINUED = 'discontinued',
  TEMP_DISCONTINUED = 'temp_discontinued',
  NOT_FOUND = 'not_found',
}

export type VendorListProductItemType = {
  product_id: number
  product_name: string
  brand_id: number
  brand_name: string
  l1_category_id: number
  l1_category_name: string
  l2_category_id: number
  l2_category_name: string
  sku_number: string
  image_url: string
  active: boolean
  selling_unit_description: string
  id?: number
  name?: string
  category_l1_id?: number
  category_l1_name?: string
  category_l2_id?: number
  category_l2_name?: string
}

export type VendorListProductCursorPaginationType = {
  next_cursor?: string
  prev_cursor?: string
  page_size?: number
}

export type GetVendorListProductResponseType = PurchaseTermsApiResponseType<
  VendorListProductItemType[]
> & {
  pagination?: VendorListProductCursorPaginationType
}

export type SearchProductsByVendorParamsType = {
  vendorId: number
  searchValue?: string
  searchType?: VendorListProductSearchTypeEnum
  pageSize?: number
  cursor?: string
}

export type GetVendorListProductParamsType = {
  vendorId: number
  brandId?: number
  ruleConfigs?: string
  brandIds?: number[]
  l1CategoryIds?: number[]
  l2CategoryIds?: number[]
  productIds?: number[]
  productTypeIds?: number[]
  searchValue?: string
  searchType?: VendorListProductSearchTypeEnum
  active?: boolean
  activeCategory?: boolean
  primaryVendor?: boolean
  sourceStatus?: VendorListProductSourceStatusEnum
  excludeSourceStatus?: VendorListProductSourceStatusEnum
  pageSize?: number
  cursor?: string
}

export type GetSkuCountResponseDataType = {
  count: number
}

export type GetSkuCountResponseType = PurchaseTermsApiResponseType<GetSkuCountResponseDataType>

export type GetSkusByBrandScopeResponseType = PurchaseTermsApiResponseType<
  BrandScopeSkuListItemType[]
>

export type BrandScopeQueryParamsType = {
  vendorId: number
  ruleConfigs?: string
  brandIds?: number[]
  l1CategoryIds?: number[]
  l2CategoryIds?: number[]
}
